module.exports = __webpack_public_path__ + "static/media/konnen-logo-mono-white.cfb78013.svg";